// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from '/home/jiajiangyuan/www/qf-react-app/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';
import LoadingComponent from '@/components/PageLoading/index';

export function getRoutes() {
  const routes = [
  {
    "path": "/",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__index' */'@/layouts/index'), loading: LoadingComponent}),
    "routes": [
      {
        "path": "/profit",
        "routes": [
          {
            "path": "/profit",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__qiangFenCent__index' */'/home/jiajiangyuan/www/qf-react-app/src/pages/qiangFenCent/index'), loading: LoadingComponent}),
            "title": "我的收益",
            "exact": true
          },
          {
            "path": "/profit/cash",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__qiangFenCent__component__CashWithdrawal' */'/home/jiajiangyuan/www/qf-react-app/src/pages/qiangFenCent/component/CashWithdrawal'), loading: LoadingComponent}),
            "title": "提现",
            "exact": true
          },
          {
            "path": "/profit/detailed",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__qiangFenCent__component__Detailed' */'/home/jiajiangyuan/www/qf-react-app/src/pages/qiangFenCent/component/Detailed'), loading: LoadingComponent}),
            "title": "我的收益",
            "exact": true
          },
          {
            "path": "/profit/register",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__qiangFenCent__component__Register' */'/home/jiajiangyuan/www/qf-react-app/src/pages/qiangFenCent/component/Register'), loading: LoadingComponent}),
            "title": "邀请用户",
            "exact": true
          },
          {
            "path": "/profit/share",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__qiangFenCent__component__Share' */'/home/jiajiangyuan/www/qf-react-app/src/pages/qiangFenCent/component/Share'), loading: LoadingComponent}),
            "title": "分享",
            "exact": true
          },
          {
            "path": "/profit/PreferentialCourses",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__qiangFenCent__component__PreferentialCourses' */'/home/jiajiangyuan/www/qf-react-app/src/pages/qiangFenCent/component/PreferentialCourses'), loading: LoadingComponent}),
            "title": "新建用户限时抢购",
            "exact": true
          }
        ]
      },
      {
        "path": "/weibo/:type",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__weiboLink__index' */'/home/jiajiangyuan/www/qf-react-app/src/pages/weiboLink/index'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/questionBank",
        "routes": [
          {
            "path": "/questionBank/home",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__questionBank__home__index' */'/home/jiajiangyuan/www/qf-react-app/src/pages/questionBank/home/index'), loading: LoadingComponent}),
            "title": "题库首页",
            "exact": true
          },
          {
            "path": "/questionBank/subject/:id",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__questionBank__subject__index' */'/home/jiajiangyuan/www/qf-react-app/src/pages/questionBank/subject/index'), loading: LoadingComponent}),
            "title": "试卷详情",
            "exact": true
          },
          {
            "path": "/questionBank/submitAnswers",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__questionBank__submitAnswers__index' */'/home/jiajiangyuan/www/qf-react-app/src/pages/questionBank/submitAnswers/index'), loading: LoadingComponent}),
            "title": "提交答案",
            "exact": true
          },
          {
            "path": "/questionBank/TopicList",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__questionBank__TopicList__index' */'/home/jiajiangyuan/www/qf-react-app/src/pages/questionBank/TopicList/index'), loading: LoadingComponent}),
            "title": "错题收藏列表",
            "exact": true
          },
          {
            "path": "/questionBank/Topic/:id",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__questionBank__Topic' */'/home/jiajiangyuan/www/qf-react-app/src/pages/questionBank/Topic'), loading: LoadingComponent}),
            "title": "错题收藏",
            "exact": true
          }
        ]
      },
      {
        "path": "/agreement",
        "routes": [
          {
            "path": "/agreement/PrivilegePrivacy",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__agreement__PrivilegePrivacy' */'/home/jiajiangyuan/www/qf-react-app/src/pages/agreement/PrivilegePrivacy'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/agreement/PrivacyClause",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__agreement__PrivacyClause' */'/home/jiajiangyuan/www/qf-react-app/src/pages/agreement/PrivacyClause'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/agreement/ThirdParty",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__agreement__ThirdParty' */'/home/jiajiangyuan/www/qf-react-app/src/pages/agreement/ThirdParty'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/agreement/Information",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__agreement__Information' */'/home/jiajiangyuan/www/qf-react-app/src/pages/agreement/Information'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "path": "/bridge",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Bridge' */'/home/jiajiangyuan/www/qf-react-app/src/pages/Bridge'), loading: LoadingComponent}),
        "exact": true
      }
    ]
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
